import { CompanyService } from '../services/CompanyService';

export function useCompanyService(): CompanyService {
  return new CompanyService(useApiClient(), useUserStore());
}
